import { Menu } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { FC, memo } from 'react';

import { messages } from './EnableSyncMenuItem.messages';
import { EnableSyncMenuItemProps } from './EnableSyncMenuItem.types';

export const EnableSyncMenuItem: FC<EnableSyncMenuItemProps> = memo((props) => {
    const { enableSync, integrationType, disabled } = props;

    const integrationName = selectors.integration.getIntegrationTypeName(integrationType);

    return (
        <Menu size='small'>
            <Menu.Item
                disabled={disabled}
                onClick={enableSync}
                name={messages.enableBudgetSyncWith({
                    integrationName,
                })}
            />
        </Menu>
    );
});

EnableSyncMenuItem.displayName = 'EnableSyncMenuItem';
